// extracted by mini-css-extract-plugin
export default {"userFullName":"userList_userFullName__TqJ-L"};